/* eslint-disable vue/valid-v-for */
<template>
  <v-navigation-drawer
    v-model="$store.state.layout.drawer"
    clipped
    app
    class="app-drawer"
  >
    <div class="drawer-header">
      <div class="drawer-brand-mark"><span></span></div>
      <div class="drawer-brand-copy">
        <div class="drawer-title"><span>smpl</span>sale</div>
        <div class="drawer-subtitle">Point of Sale</div>
      </div>
      <div class="drawer-version">v{{ version }}</div>
    </div>

    <v-list dense nav class="drawer-list">
      <template v-for="item in items">
        <div
          v-if="item.header"
          :key="item.header"
          class="drawer-section-label"
        >
          {{ item.header }}
        </div>

        <v-list-group
          v-else-if="item.children"
          :key="item.title"
          v-model="item.model"
          :prepend-icon="item.icon"
          :append-icon="item.model ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          class="drawer-group"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="drawer-item-title">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, i) in item.children"
            :key="`${item.name}-${i}`"
            :to="child.path"
            class="drawer-child-item"
            @click="child.click && child.click()"
            link
          >
            <v-list-item-action v-if="child.icon" class="drawer-action">
              <v-icon small>{{ child.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="drawer-child-title">
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider
          v-else-if="item.divider"
          :key="item.name || item.title || 'divider'"
          class="drawer-divider"
        />

        <v-list-item
          v-else
          :key="item.title"
          link
          :to="item.path"
          :exact="item.path === '/'"
          class="drawer-item"
          @click="item.click && item.click()"
        >
          <v-list-item-action class="drawer-action">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="drawer-item-title">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider class="drawer-divider" />

      <div class="drawer-utility">
        <ImeiSearch />
        <RestockSerial />
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const ImeiSearch = () => import("@/components/ImeiSearch");
const RestockSerial = () => import("@/components/RestockSerial");
const pjson = require("../../../../package.json");

export default {
  name: "navigation-panel",

  components: {
    ImeiSearch,
    RestockSerial,
  },

  data() {
    return {
      items: [],
      mini: false,
      right: null,
      leadsBadge: 0,
      ticketsBadge: 0,
      taskBadge: 0,
      inventoryBadge: 0,
      locationBadge: 0,
    };
  },

  computed: {
    ...mapGetters("integration", ["modules"]),

    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),

    version() {
      return pjson.version;
    },
  },

  watch: {
    currentBusiness: {
      deep: true,
      handler() {
        this.loadNav();
      },
    },
  },

  async created() {
    await this.initUser();
    await this.loadNav();
  },

  methods: {
    ...mapActions("layout", ["setOpenSerialSearch", "setOpenRestockSerial"]),

    ...mapActions("global", [
      "setGlobalStatus",
      "setLoginDialog",
      "initUser",
      "initType",
    ]),

    loadNav() {
      this.items = [];

      this.items.push({ header: "Main" });

      this.items.push({
        title: this.$t("sideBar.home"),
        icon: "mdi-home-outline",
        name: "home",
        path: "/",
      });

      this.items.push({
        title: "Customer",
        icon: "mdi-account-outline",
        name: "customer",
        path: "/customer",
      });

      this.items.push({
        title: "Inventory",
        icon: "mdi-warehouse",
        name: "inventory",
        path: "/inventory",
        children: this.getInventoryItem(),
      });

      if (this.checkRightStatus(67)) {
        this.items.push({
          title: "Orders",
          icon: "mdi-book-open-outline",
          name: "order",
          path: "/order",
        });
      }

      if (this.checkRightStatus(63)) {
        this.items.push({
          title: "Invoices",
          icon: "mdi-cart-outline",
          name: "invoice",
          path: "/invoice",
        });
      }

      this.items.push({
        title: "Delivery",
        icon: "mdi-truck-delivery-outline",
        name: "Delivery",
        path: "/Delivery",
      });

      if (this.checkRightStatus(61)) {
        this.items.push({
          title: "Leads",
          icon: "mdi-filter-outline",
          name: "leads",
          path: "/lead",
        });
      }

      if (this.checkRightStatus(62)) {
        this.items.push({
          title: "Products",
          icon: "mdi-cellphone-android",
          name: "product",
          path: "/product/list",
        });
      }

      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.workOrder
      ) {
        this.items.push({
          title: "Work Order",
          icon: "mdi-book-open-outline",
          name: "workOrder",
          path: "/workOrder/list",
        });
      }

      if (this.checkRightStatus(66)) {
        this.items.push({
          title: "Expense",
          icon: "mdi-wallet-outline",
          name: "expense",
          path: "/expense",
        });
      }

      if (this.checkRightStatus(51)) {
        this.items.push({
          title: "Report",
          icon: "mdi-chart-bell-curve",
          name: "report",
          path: "/report/home",
        });
      }

      if (
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.serializeProduct &&
        this.checkRightStatus(65)
      ) {
        this.items.push({
          title: "Serial Search",
          icon: "mdi-feature-search-outline",
          name: "serailSearch",
          click: () => {
            this.setOpenSerialSearch(true);
          },
        });
      }

      this.items.push({ divider: true });
      this.items.push({ header: "Manage" });

      const listItems = this.getListItem();

      if (listItems.length > 0) {
        this.items.push({
          title: this.$t("sideBar.list"),
          icon: "mdi-format-list-bulleted-square",
          name: "list",
          path: "",
          children: listItems,
        });
      }

      if (this.checkRightStatus(64)) {
        this.items.push({
          title: "Deleted",
          icon: "mdi-delete-clock-outline",
          name: "deleted",
          path: "",
          children: [
            {
              name: "deleteCustomer",
              icon: "mdi-account-off-outline",
              title: "Deleted Customer",
              path: "/customer/deleted",
            },
            {
              name: "deletedInvoice",
              title: "Deleted Invoice",
              icon: "mdi-receipt-text-remove-outline",
              path: "/invoice/deleted",
            },
            {
              name: "deletedPayment",
              title: "Deleted Payments",
              icon: "mdi-currency-usd-off",
              path: "/customer/payment/deleted",
            },
          ],
        });
      }

      this.items.push({
        title: "Admin Tools",
        icon: "mdi-account-key-outline",
        name: "adminTools",
        path: "/adminTools/home",
      });
    },

    getListItem() {
      const list = [];

      if (this.checkRightStatus(70)) {
        list.push({
          name: "payee",
          icon: "mdi-account-check-outline",
          title: "Payee",
          path: "/expense/payee/list",
        });
      }

      if (this.checkRightStatus(68)) {
        list.push({
          name: "vendor",
          icon: "mdi-truck-outline",
          title: "Vendor",
          path: "/inventory/vendor",
        });
      }

      if (this.checkRightStatus(69)) {
        list.push({
          name: "payments",
          icon: "mdi-cash-multiple",
          title: "Payments",
          path: "/customer/payment/home",
        });
      }

      return list;
    },

    getInventoryItem() {
      const list = [];

      if (this.checkRightStatus(38)) {
        list.push({
          name: "purchase",
          icon: "mdi-package-variant-closed",
          title: "Purchase",
          path: "/inventory/purchase",
        });
      }

      if (this.checkRightStatus(48)) {
        list.push({
          name: "purchaseOrder",
          icon: "mdi-package-variant",
          title: "Purchase Order",
          path: "/inventory/purchaseOrder",
        });
      }

      if (this.checkRightStatus(38)) {
        list.push({
          name: "inboundDelivery",
          icon: "mdi-truck-check-outline",
          title: "Inbound Delivery",
          path: "/inventory/inboundDelivery/list",
        });
      }

      if (
        this.currentBusiness &&
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.invoiceExitGuardEnabled
      ) {
        list.push({
          name: "warehouseExit",
          icon: "mdi-shield-check-outline",
          title: "Warehouse Exit",
          path: "/inventory/warehouseExit/list",
        });
      }

      if (this.checkRightStatus(68)) {
        list.push({
          name: "vendor",
          icon: "mdi-truck-outline",
          title: "Vendor",
          path: "/inventory/vendor",
        });
      }

      if (
        this.currentBusiness &&
        this.currentBusiness.metadata &&
        this.currentBusiness.metadata.serializeProduct &&
        this.checkRightStatus(71)
      ) {
        list.push({
          name: "serail",
          icon: "mdi-barcode",
          title: "Serial",
          path: "/inventory/serial/list",
        });
      }

      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-drawer {
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
}

.drawer-header {
  min-height: 76px;
  padding: 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
}

.drawer-brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: linear-gradient(145deg, #2dd4bf, #14b8a6);
  box-shadow: 0 7px 16px rgba(20, 184, 166, 0.2);
  display: grid;
  place-items: center;
  flex: 0 0 auto;
}

.drawer-brand-mark span {
  width: 16px;
  height: 3px;
  border-radius: 999px;
  background: #ffffff;
}

.drawer-brand-copy {
  min-width: 0;
  flex: 1;
}

.drawer-title {
  font-size: 19px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.1;
  letter-spacing: -0.04em;
}

.drawer-title span {
  color: #2dd4bf;
}

.drawer-subtitle {
  font-size: 10px;
  color: #64748b;
  margin-top: 4px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.drawer-version {
  padding: 3px 6px;
  border-radius: 7px;
  background: #f1f5f9;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.drawer-list {
  padding: 8px 8px 18px;
}

.drawer-section-label {
  font-size: 11px;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 15px 10px 7px;
}

.drawer-item,
.drawer-group {
  border-radius: 12px;
  margin-bottom: 3px;
  overflow: hidden;
}

.drawer-child-item {
  min-height: 38px;
  border-radius: 10px;
  margin-left: 16px;
  margin-right: 4px;
  margin-bottom: 2px;
}

.drawer-action {
  min-width: 32px !important;
  margin-right: 8px !important;
}

.drawer-item .drawer-action {
  width: 32px;
  height: 32px;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  border-radius: 10px;
  background: #f1f5f9;
  display: grid;
  place-items: center;
}

.drawer-item-title {
  font-size: 14px;
  font-weight: 700;
  color: #334155;
}

.drawer-child-title {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.drawer-divider {
  margin: 12px 6px 2px;
}

.drawer-utility {
  padding: 6px 0 0;
}

::v-deep .drawer-item,
::v-deep .drawer-group > .v-list-group__header {
  min-height: 44px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

::v-deep .drawer-group > .v-list-group__header {
  border-radius: 12px;
  padding-left: 12px;
}

::v-deep .drawer-group > .v-list-group__header .v-list-item__icon:first-child {
  width: 32px;
  min-width: 32px;
  height: 32px;
  margin: 6px 8px 6px 0;
  border-radius: 10px;
  background: #f1f5f9;
  display: grid;
  place-items: center;
}

::v-deep .drawer-group > .v-list-group__header .v-list-item__icon:last-child {
  min-width: 22px;
  margin-left: 4px;
}

::v-deep .drawer-item:hover,
::v-deep .drawer-group > .v-list-group__header:hover,
.drawer-child-item:hover {
  background: #ffffff !important;
}

::v-deep .v-list-item--active {
  background: #ffffff !important;
  color: #2563eb !important;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.07);
}

::v-deep .drawer-item.v-list-item--active::before,
::v-deep .drawer-child-item.v-list-item--active::before {
  opacity: 1;
  background: #2563eb;
  width: 3px;
  left: 0;
  right: auto;
  border-radius: 0 4px 4px 0;
}

::v-deep .drawer-item.v-list-item--active .drawer-action,
::v-deep .drawer-group.v-list-group--active > .v-list-group__header .v-list-item__icon:first-child {
  background: #eff6ff;
}

::v-deep .v-list-item--active .v-icon,
::v-deep .v-list-item--active .drawer-item-title,
::v-deep .v-list-item--active .drawer-child-title {
  color: #2563eb !important;
}

::v-deep .drawer-group.v-list-group--active > .v-list-group__header .drawer-item-title,
::v-deep .drawer-group.v-list-group--active > .v-list-group__header > .v-list-item__icon .v-icon {
  color: #2563eb !important;
}

::v-deep .v-navigation-drawer__content {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 5px;
}

::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.v-chip--x-small {
  font-size: 10px;
  height: 16px;
}

.v-chip--x-small .v-chip__content {
  line-height: 1;
  padding: 8px;
}
</style>
